<template>
    <div>
        <v-row>
            <v-col cols="2">
                <div>
                  <v-text-field v-model="filters.city" label="Miasto" prepend-icon="mdi-city"></v-text-field>
                    <v-menu
                            v-model="menu4"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="filters.dateFrom"
                            label="Data podstawienia"
                            prepend-icon="mdi-calendar-blank"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          v-model="filters.dateFrom"
                          :first-day-of-week="1"
                          @input="menu1 = false"
                      ></v-date-picker>
                    </v-menu>
                  <v-menu
                      v-model="menu2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="filters.dateTo"
                          label="Data zwrotu"
                          prepend-icon="mdi-calendar-blank"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="filters.dateTo"
                        :first-day-of-week="1"
                        @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </div>
                <v-autocomplete
                    v-model="filters.company"
                    label="Wypożyczalnia (wybrana oferta)"
                    prepend-icon="mdi-store"
                    :items="companies"
                    item-value="id"
                    item-text="name"
                    clearable
                ></v-autocomplete>
                <div>
                    <v-chip-group v-model="filters.status" column active-class="primary--text" multiple>
                        <v-chip v-for="(key, status) in statuses" :key="status" :value="status">
                            {{ getStatusText(status) }}
                        </v-chip>
                    </v-chip-group>
                </div>
                <v-btn @click="get();" color="primary" block>Filtruj</v-btn>
            </v-col>
            <v-col cols="10">
                <data-table
                        ref="table"
                        :headers="headers"
                        :items="items"
                        :options.sync="options"
                        :server-items-length="total"
                        :loading="loading"
                        class="elevation-1 row-pointer"
                        @click:row="(wholesaleInquiry) => $router.push({name: 'wholesale-inquiry-details', params: { id: wholesaleInquiry.id }}).catch(()=>{})"
                >
                    <template v-slot:item.category="{ item }">
                        {{ getCategoryText(item.category) }}
                    </template>
                    <template v-slot:item.dateFrom="{ item }">
                        {{ localDateTime(item.dateFrom) }}
                    </template>
                    <template v-slot:item.dateTo="{ item }">
                        {{ localDateTime(item.dateTo) }}
                    </template>
                    <template v-slot:item.urgent="{ item }">
                        {{ item.urgent ? 'Tak' : 'Nie' }}
                    </template>
                    <template v-slot:item.status="{ item }">
                        {{ getStatusText(item.status) }}
                    </template>

                    <template v-slot:item.error="{ item }">
                        {{ item.error }}
                    </template>
                </data-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import api from '../services/api';
    import DataTable from "@/components/data-table/DataTable";
    import formatters from '@/mixins/formatters';
    import {getDatatableParams, setDatatableOptions, setDatatableFilters} from '@/utils/helpers';
    import {getStatusText, WholesaleInquiryStatus} from '@/enums/WholesaleInquiryStatus';
    import {getCategoryText} from '@/enums/WholesaleInquiryCategory';
    import moment from 'moment';
    import permissions from '@/mixins/permissions';

    export default {
        mixins: [
            formatters,
            permissions,
        ],
        components: {
          DataTable,
        },
        data () {
            return {
                statuses: WholesaleInquiryStatus,
                modal: false,
                menu1: false,
                menu2: false,
                menu3: false,
                menu4: false,
                filters: {
                    status: null,
                    company: null,
                },
                companies: [],
                total: 0,
                items: [],
                loading: true,
                options: {},
                headers: [
                    { text: 'ID', value: 'id', sortable: false },
                    { text: 'Kategoria', value: 'category', sortable: false },
                    { text: 'Miasto', value: 'city', sortable: false },
                    { text: 'Ilość pojazdów', value: 'numberOfCars', sortable: false },
                    { text: 'Data postawienia', value: 'dateFrom', sortable: false },
                    { text: 'Data zwrotu', value: 'dateTo', sortable: false },
                    { text: 'Pilne', value: 'urgent', sortable: false },
                    { text: 'Status', value: 'status', sortable: false },
                    { text: 'Źródło', value: 'sourcePageTitle', sortable: false },
                ],
                reactOnFilterChange: true,
                stats: [],
            }
        },
        watch: {
            options: {
                handler () {
                    this.get();
                },
                deep: true,
            },
            filters: {
                handler() {
                    if (!this.reactOnFilterChange) {
                        return;
                    }

                    setDatatableFilters.call(this);
                },
                deep: true
            },

        },
        methods: {
          getCategoryText,
            async get() {
                this.loading = true;

                const { page, itemsPerPage } = this.options;

                if (this.filters.dateFrom) {
                    const dateFromString = String(this.filters.dateFrom).substr(0, 10);
                    this.reactOnFilterChange = false;

                    if (!moment(dateFromString).isValid()) {
                      this.filters.dateFrom = this.getDateFrom();
                    } else {
                      this.filters.dateFrom = dateFromString;
                    }

                    this.reactOnFilterChange = true;
                }

                let filters = this.filters

                if (filters.phone) {
                    filters.phone = filters.phone.replace(/\D*(\d{3})\D*(\d{3})\D*(\d{3})\D*/, '$1 $2 $3');
                }

                const params = {
                    offset: page > 1 ? itemsPerPage*(page-1) : 0,
                    ...this.filters
                };

                if (-1 !== itemsPerPage) {
                    params.limit = itemsPerPage;
                }

                if (!params.status) {
                    delete params.status;
                }

                if (!params.company) {
                    delete params.company;
                }

                const response = await api.get('/api/wholesale-inquiries', {params});
                this.loading = false;

                this.items = response.data.items;
                this.total = response.data.total;
                this.reactOnFilterChange = false;

                setDatatableOptions.call(this);

                setTimeout(() => {
                    this.reactOnFilterChange = true;
                }, 1000); // Delay the change a bit to avoid performing another query.
            },
            getStatusText(status) {
                return getStatusText(status);
            },
            async loadCompanies() {
                try {
                    const response = await api.get('/api/price-list/company?rental=true');
                    this.companies = response.data.items;
                } catch (error) {
                    console.error('Error when loading companies: ', error);
                }
            },
        },
        created() {
            getDatatableParams.call(this);
            this.loadCompanies();
            for (const [key] of Object.entries(this.statuses)) {
                this.stats[key] = 0;
            }
        }
    }
</script>

<style lang="css" scoped>
    .row-pointer >>> td {
      height: auto !important;
      padding: 0.5rem !important;
    }
    .row-pointer >>> tbody tr :hover {
        cursor: pointer;
    }
    .v-chip {
        white-space: break-spaces !important;
        line-height: 14px;
        width: 100%;
        padding: 9px;
    }

    .v-chip .v-chip__content {
        max-width: 100%;
        height: auto;
        overflow: auto;
        min-height: 32px;
        white-space: pre-wrap;
    }
</style>